import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H3 } from 'UIComponents/elements/headings';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { useEffect } from 'react';
import { SCREENS } from '../../constants/tracking/Locations';
import ComparePlansLink from '../suite-starter-page/ComparePlansLink';
import { LimitUsageFeatureRow } from './LimitUsageFeatureRow';
const LimitUsageContainer = styled.div.withConfig({
  displayName: "LimitUsageSection__LimitUsageContainer",
  componentId: "sc-1ev2pah-0"
})(["width:100%;max-width:100%;"]);
export const FeatureTooltip = props => {
  return /*#__PURE__*/_jsx(UITooltip, {
    maxWidth: 400,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `pricing-pages.features.${props.name}.description.default`
    }),
    children: props.children
  });
};

const LimitUsageSection = ({
  limitUsages
}) => {
  const checkForUsage = () => limitUsages.some(obj => obj.usage > 0);

  useEffect(() => {
    getUsageTracker().track('limitUsageView', {
      screen: SCREENS.SUITE_STARTER,
      hasUsageOnLimits: checkForUsage()
    }); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      style: {
        paddingTop: 24
      },
      children: /*#__PURE__*/_jsx(ComparePlansLink, {})
    }), /*#__PURE__*/_jsxs(LimitUsageContainer, {
      className: "text-center m-y-5",
      children: [/*#__PURE__*/_jsx(H3, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EBX638.LimitUsageSection.title"
        })
      }), limitUsages.map(limitUsage => {
        return /*#__PURE__*/_jsx(LimitUsageFeatureRow, {
          limitUsage: limitUsage
        }, limitUsage.limitName);
      })]
    })]
  });
};

export default LimitUsageSection;